import { BrandCard } from "@shltelemedicine/shl-ui-lib";
import { useSearchParams } from "react-router-dom";
import { Constants } from "../../constants";
import styles from "./ForgotPassword.module.css";
import ForgotPasswordForm from "./ForgotPasswordForm/ForgotPasswordForm";
import Disclaimer from "../Disclaimer/Disclaimer";

const ForgotPassword = () => {
  const [searchParams] = useSearchParams();

  const username = searchParams.get(
    Constants.FORGOT_PASSWORD_TOKEN_USERNAME_KEY
  );
  const mobile = searchParams.get(
    Constants.FORGOT_PASSWORD_TOKEN_MOBILE_KEY
  ) as "0" | "1" | null;

  return (
    <>
      <BrandCard className={styles.wrapper} contentClassName="mb-3">
        <ForgotPasswordForm username={username ?? ""} mobile={mobile} />
      </BrandCard>
      <div className={`${styles.warning} text-center mx-sm`}>
        <p className="mt-3 mb-0">
          <Disclaimer />
        </p>
      </div>
    </>
  );
};

export default ForgotPassword;
